import {Fancybox} from "@fancyapps/ui";

export default class SuccessModal {
    constructor(url) {
        let _url = new URL(url);
        _url.searchParams.append('action', 'getSuccess');
        new Fancybox([
            {
                src: _url,
                type: "ajax",
            },
        ], {
            trapFocus: false,
            autoFocus: false,
            tpl: {
                closeButton: false,
            },
        });
    }
}